import type { ComponentType } from "react";

type PageModule = Promise<{ default: ComponentType }>;

/**
 * Every code-split page, loaded through one function each so the router and
 * the idle preloader share a single import (and Vite's module cache).
 */
export const PAGES = {
  login: (): PageModule => import("@/features/auth/routes/login"),
  authCallback: (): PageModule => import("@/features/auth/routes/auth-callback"),
  teamsSignInStart: (): PageModule => import("@/features/auth/routes/teams-sign-in-start"),
  teamsSignInEnd: (): PageModule => import("@/features/auth/routes/teams-sign-in-end"),
  staffHome: (): PageModule => import("@/features/staff-home/routes/staff-home"),
  department: (): PageModule => import("@/features/departments/routes/department"),
  document: (): PageModule => import("@/features/documents/routes/document-detail"),
  activity: (): PageModule => import("@/features/activities/routes/activity-detail"),
  guide: (): PageModule => import("@/features/guide/routes/guide"),
  adminUsers: (): PageModule => import("@/features/admin/routes/admin-users"),
  adminContent: (): PageModule => import("@/features/admin/routes/admin-content"),
  notFound: (): PageModule => import("@/components/not-found"),
};

/** A route's `lazy` for a page module's default export. */
export function lazyPage(load: () => PageModule) {
  return () => load().then((module) => ({ Component: module.default }));
}
